var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.homePath === '/')?_c('navbar-main'):_vm._e(),_c('router-view',{key:_vm.$route.name + (_vm.$route.params.id || '')}),(!['Preview', 'Builder'].includes(_vm.$route.name))?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }